import axios from 'axios'
import { POST_CBM_LAUNCH_URL, POST_QQ_LAUNCH_URL, POST_CBM_STATUS_UPDATE_URL } from '../constants/urls'

export async function getCbmLaunchUrl(fxbuyflowSessionId, isCbmAdded) {
  const { data: res } = await axios.post(POST_CBM_LAUNCH_URL, {
    fxbuyflowSessionId,
    isCbmAdded
  })
  return res.data.xfinityMobileLaunchUrl ?? null
}

export async function CbmStatusUpdate(fxbuyflowSessionId, isCbmAdded) {
  const { data: res } = await axios.post(POST_CBM_STATUS_UPDATE_URL, {
    fxbuyflowSessionId,
    isCbmAdded
  })
  return res.data
}


export async function getQQUrl(body) {
  const { data: res } = await axios.post(POST_QQ_LAUNCH_URL, body)
  
  const qqURL = res?.quickQuoteBaseUrl + res?.guid
  return qqURL
}
